import { e as error, j as json } from "../../../../chunks/index2.js";
import { randomUUID } from "crypto";
import admin from "firebase-admin";
import { s as stripe } from "../../../../chunks/stripe.js";
import { c as sendLicenseEmail } from "../../../../chunks/mailer.js";
import { b as STRIPE_WEBHOOK_SECRET } from "../../../../chunks/private.js";
const generateLicenseAndNotifyUser = async (paymentIntent) => {
  const license = randomUUID().toUpperCase();
  const customer = await stripe.customers.retrieve(paymentIntent.customer);
  if (customer.deleted || !customer.email) return null;
  await admin.firestore().collection("licenses").doc(customer.email).set({
    code: license
  });
  await sendLicenseEmail(customer.email, license);
};
const POST = async ({ request }) => {
  const sig = request.headers.get("stripe-signature");
  let event;
  try {
    event = stripe.webhooks.constructEvent(
      Buffer.from(await request.arrayBuffer()),
      sig,
      STRIPE_WEBHOOK_SECRET
    );
  } catch (err) {
    console.error(err);
    return error(400, { message: `Webhook Error: ${err.message}` });
  }
  const type = event.type;
  if (type === "payment_intent.succeeded") {
    await generateLicenseAndNotifyUser(event.data.object);
  }
  return json({
    received: true
  });
};
export {
  POST
};
